<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>
    <div v-if="seo">
      <div class="columns is-multiline">
        <div class="column is-half">
          <div class="box">
            <admin-box-item title="검색 로봇 접근 제어 설정"
                            :useTab="false">
              <admin-form-item label="robots.txt 내용">
                <textarea class="textarea"
                          rows="10"
                          cols="10"
                          v-model="seo.robots"></textarea>
              </admin-form-item>
            </admin-box-item>
          </div>
        </div>
        <div class="column is-half">
          <div class="box">
            <admin-box-item title="검색 엔진 수집 정보"
                            :useTab="false">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="title">
                    <input class="input"
                           type="text"
                           @input="e=>seo.title=e.target.value"
                           :value="seo.title">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="author">
                    <input class="input"
                           type="text"
                           @input="e=>seo.author=e.target.value"
                           :value="seo.author">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="description">
                    <input class="input"
                           type="text"
                           @input="e=>seo.description=e.target.value"
                           :value="seo.description">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="keywords" desc="키워드는 콤마(,)로 구분하여 입력할 수 있습니다. (예 상의, 하의)">
                    <input class="input"
                           type="text"
                           @input="e=>seo.keywords=e.target.value"
                           :value="seo.keywords">
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>
        <div class="column is-half">
          <div class="box">
            <admin-box-item title="오픈 그래프 태그">
              <div class="columns is-multiline">
                <div class="column is-full">
                  <admin-form-item label="title">
                    <input class="input"
                           type="text"
                           @input="e=>seo.og_title=e.target.value"
                           :value="seo.og_title">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="description">
                    <input class="input"
                           type="text"
                           @input="e=>seo.og_description=e.target.value"
                           :value="seo.og_description">
                  </admin-form-item>
                </div>
                <div class="column is-full">
                  <admin-form-item label="image">
                    <input-img :url.sync="seo.og_image"></input-img>
                  </admin-form-item>
                </div>
              </div>
            </admin-box-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import InputImg from "../../module/common/InputImg";
  export default {
    name: "SeoSetting",
    components: {InputImg},
    created() {
      // this.getData();
    },
    data() {
      return {
        seo: undefined
      }
    },
    methods: {
      save() {

      },
      getData () {
        this.$axios.get('admin/service/social_key')
          .then(res => {
            if (res.status === 200) {
              this.value = this.cloneItem(res.data);
            }
          });
      },
    }
  }
</script>
<style lang="stylus" scoped>
</style>
